var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44006 25.3468L3.4134 25.3735C3.0534 24.5868 2.82673 23.6935 2.7334 22.7068C2.82673 23.6801 3.08006 24.5601 3.44006 25.3468Z",
    fill: "#84CC16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8401C13.7526 13.8401 15.1733 12.4193 15.1733 10.6667C15.1733 8.91416 13.7526 7.49341 12 7.49341C10.2474 7.49341 8.82666 8.91416 8.82666 10.6667C8.82666 12.4193 10.2474 13.8401 12 13.8401Z",
    fill: "#84CC16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5868 2.66675H10.4134C5.56008 2.66675 2.66675 5.56008 2.66675 10.4134V21.5868C2.66675 23.0401 2.92008 24.3067 3.41341 25.3734C4.56008 27.9067 7.01341 29.3334 10.4134 29.3334H21.5868C26.4401 29.3334 29.3334 26.4401 29.3334 21.5868V18.5334V10.4134C29.3334 5.56008 26.4401 2.66675 21.5868 2.66675ZM27.1601 16.6667C26.1201 15.7734 24.4401 15.7734 23.4001 16.6667L17.8534 21.4267C16.8134 22.3201 15.1334 22.3201 14.0934 21.4267L13.6401 21.0534C12.6934 20.2267 11.1867 20.1467 10.1201 20.8667L5.13341 24.2134C4.84008 23.4667 4.66675 22.6001 4.66675 21.5868V10.4134C4.66675 6.65341 6.65341 4.66675 10.4134 4.66675H21.5868C25.3468 4.66675 27.3334 6.65341 27.3334 10.4134V16.8134L27.1601 16.6667Z",
    fill: "#84CC16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFileIcon);
export default __webpack_public_path__ + "static/media/ImageFileIcon.329fb824af12524679d4b6e114f15050.svg";
export { ForwardRef as ReactComponent };